export interface VasRateActionTypes {
  type: VasRateActions;
  payload?: any;
}

export enum VasRateActions {
  CREATE_VAS_RATE = "CREATE_VAS_RATE",
  GET_VAS_RATE_LIST = "GET_VAS_RATE_LIST",
  SET_VAS_RATE_LIST = "SET_VAS_RATE_LIST",
  SET_VAS_RATE_LIST_PAGE_COUNT = "SET_VAS_RATE_LIST_PAGE_COUNT",
  GET_VAS_RATE_DATA_BY_ID = "GET_VAS_RATE_DATA_BY_ID",
  SET_VAS_RATE_DATA_BY_ID = "SET_VAS_RATE_DATA_BY_ID",
  EDIT_VAS_RATE_DATA_BY_ID = "EDIT_VAS_RATE_DATA_BY_ID",
}
